import axios from 'axios'
import qs from 'qs'
import errorHandler from './error-handler'

export default {
  async search (query) {
    return axios.get(`/api/jobs?${qs.stringify(query)}`)
      .then(r => r.data).catch(errorHandler)
  },
  async applied (query) {
    return axios.get(`/api/jobs/applied?${qs.stringify(query)}`)
      .then(r => r.data).catch(errorHandler)
  },
  async hired (query) {
    return axios.get(`/api/jobs/hired?${qs.stringify(query)}`)
      .then(r => r.data).catch(errorHandler)
  },
  async searchVisited (query) {
    return axios.get(`/api/jobs/visited?${qs.stringify(query)}`)
      .then(r => r.data).catch(errorHandler)
  },
  async get (jobId) {
    return axios.get(`/api/jobs/${jobId}`)
      .then(r => r.data).catch(errorHandler)
  },
  async viewed (jobId) {
    return axios.post(`/api/jobs/${jobId}/view`)
      .then(r => r.data).catch(errorHandler)
  },
  async application (jobId) {
    return axios.get(`/api/jobs/${jobId}/application`)
      .then(r => r.data).catch(errorHandler)
  },
  async deleteApplication (jobId) {
    return axios.delete(`/api/jobs/${jobId}/application`)
      .then(r => r.data).catch(errorHandler)
  },
  async offer (jobId) {
    return axios.get(`/api/jobs/${jobId}/offer`)
      .then(r => r.data).catch(errorHandler)
  },
  async rejectOffer (offerId) {
    return axios.post(`/api/offers/${offerId}/reject`)
      .then(r => r.data).catch(errorHandler)
  },
  async acceptOffer (offerId) {
    return axios.post(`/api/offers/${offerId}/accept`)
      .then(r => r.data).catch(errorHandler)
  },
  async apply ({ jobId, coverLetter, signupBoard }) {
    return axios.post(`/api/jobs/${jobId}/apply`, { coverLetter, signupBoard })
      .then(r => r.data).catch(errorHandler)
  },
  async all () {
    return axios.get('/api/jobs/all').then(r => r.data).catch(errorHandler)
  },
  async create (data) {
    return axios.post('/api/jobs', data).then(r => r.data).catch(errorHandler)
  },
  async update (jobId, data) {
    return axios.put(`/api/jobs/${jobId}`, data)
      .then(r => r.data).catch(errorHandler)
  },
  async remove (jobId) {
    return axios.delete(`/api/jobs/${jobId}`)
      .then(r => r.data).catch(errorHandler)
  },
  async companyJobs (companyId) {
    return axios.get(`/api/jobs/company/${companyId}`).then(r => r.data).catch(errorHandler)
  },
  async companyPublishedjobs (companyId) {
    return axios.get(`/api/jobs/company/${companyId}?status=published`).then(r => r.data).catch(errorHandler)
  },
  async getJobBoards () {
    return axios.get(`/api/job_board/`).then(r => r.data).catch(errorHandler)
  },
  async getJobBoardList () {
    return axios.get('/api/job_board/list').then(r => r.data).catch(errorHandler)
  },
  async getMyBoardJobs () {
    return axios.get('/api/job_board/jobs').then(r => r.data).catch(errorHandler)
  },
  async getJobTags () {
    return axios.get('/api/tags/suggested').then(r => r.data.suggested).catch(errorHandler)
  },
  async generateAiJobDescription (description) {
    return axios.post('/api/chatgpt/job-description', {request: description}).then(r => r.data).catch(errorHandler)
  }
}



// WEBPACK FOOTER //
// ./src/api/jobs.js